import React from "react";
import { findDisplayName } from "../../../../utils/commonFunctionsAndStatices";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPortId } from "../../../Store/actions/portId/portIdReducer";
import { selectFilterData } from "../../../Store/actions/portData/selectPortData";
import DataNotFound from "../../DataNotFound/DataNotFound";
import Pagination from "../Pagination";

const PortTable = ({ loading , totalCount , setPageNo, setCurrentPage, currentPage}) => {
  const filterData = useSelector(selectFilterData);
  const itemsPerPage = 100;

  const pages = Math.ceil(totalCount / itemsPerPage);
  const totalPages = pages;

  const onPageChange = (pageNumber) => {
    setPageNo(pageNumber);
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleNavigation = (id) => {
    dispatch(setPortId(id));
    navigate("/CheckInPage");
  };

  let data = filterData.length !== 0 ? filterData : [];

  return (
    <>
      {loading ? (
        <div className="row d-flex pt-2 justify-content-center align-items-center">
          <div
            className="card mt-3 col-md-9 col-sm-12 pt-2 "
            style={{ height: 400 }}
          >
            <div
              className="text-center text-white d-flex justify-content-center align-items-center"
              style={{ height: "100%" }}
            >
              <span
                className="spinner-border spinner-border-sm text-white pe-1 me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </div>
          </div>
        </div>
      ) : !data || data?.length === 0 ? (
        <div className="row d-flex pt-2 justify-content-center align-items-center">
          <div className="card mt-3 col-md-9 col-sm-12 pt-2">
            <DataNotFound />
          </div>
        </div>
      ) : (
        <div className="row d-flex pt-2 justify-content-center align-items-center">
          <div className="col-md-6 col-sm-12 ps-0 pe-0 card rounded-4">
            <div className="table-scrol">
              <table className="table">
                <thead className="bg-transparent">
                  <tr>
                    <th scope="col"  className="bg-transparent th-color ps-5" >
                      {findDisplayName("portTablePortNameHeading", "Port Name")}
                    </th>
                    <th scope="col"  className="bg-transparent th-color" >
                      {findDisplayName("portTableSelectHeading", "Select")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td className="ps-5  bg-transparent text-white">{item.port_name}</td>
                      <td className="ps-2  bg-transparent text-white">
                        <button
                          className="btn btn-primary"
                          onClick={() => handleNavigation(item.port)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="14"
                            viewBox="0 0 15 14"
                            fill="none"
                            className="me-2"
                          >
                            <path
                              d="M10.1667 2C10.719 2 11.1667 1.55228 11.1667 1C11.1667 0.447715 10.719 0 10.1667 0V2ZM14.5 7C14.5 6.44772 14.0523 6 13.5 6C12.9477 6 12.5 6.44772 12.5 7H14.5ZM2.95603 12.7094L3.41002 11.8183H3.41002L2.95603 12.7094ZM1.79065 11.544L2.68166 11.09L2.68166 11.09L1.79065 11.544ZM12.044 12.7094L11.59 11.8183H11.59L12.044 12.7094ZM13.2094 11.544L12.3183 11.09V11.09L13.2094 11.544ZM1.79065 2.45603L0.899643 2.00203L0.899643 2.00203L1.79065 2.45603ZM2.95603 1.29065L2.50203 0.399643L2.50203 0.399643L2.95603 1.29065ZM7.77819 8.09516L7.06862 7.39052L7.06862 7.39052L7.77819 8.09516ZM14.2096 3.03797C14.5987 2.64609 14.5965 2.01293 14.2046 1.62377C13.8128 1.23461 13.1796 1.23681 12.7904 1.62869L14.2096 3.03797ZM7.30514 8.09516L8.01471 7.39052L8.01471 7.39052L7.30514 8.09516ZM5.5429 4.90142C5.15374 4.50954 4.52058 4.50733 4.12869 4.89649C3.73681 5.28566 3.73461 5.91882 4.12377 6.3107L5.5429 4.90142ZM9.23333 12H5.76667V14H9.23333V12ZM2.5 8.73333V5.26667H0.5V8.73333H2.5ZM5.76667 2H10.1667V0H5.76667V2ZM12.5 7V8.73333H14.5V7H12.5ZM5.76667 12C5.00343 12 4.49114 11.9992 4.09664 11.967C3.71381 11.9357 3.53076 11.8799 3.41002 11.8183L2.50203 13.6004C2.95172 13.8295 3.42726 13.919 3.93377 13.9603C4.42861 14.0008 5.03643 14 5.76667 14V12ZM0.5 8.73333C0.5 9.46357 0.499222 10.0714 0.539652 10.5662C0.581036 11.0727 0.670518 11.5483 0.899643 11.998L2.68166 11.09C2.62013 10.9692 2.56429 10.7862 2.53301 10.4034C2.50078 10.0089 2.5 9.49657 2.5 8.73333H0.5ZM3.41002 11.8183C3.09641 11.6586 2.84144 11.4036 2.68166 11.09L0.899643 11.998C1.25118 12.6879 1.81211 13.2488 2.50203 13.6004L3.41002 11.8183ZM9.23333 14C9.96357 14 10.5714 14.0008 11.0662 13.9603C11.5727 13.919 12.0483 13.8295 12.498 13.6004L11.59 11.8183C11.4692 11.8799 11.2862 11.9357 10.9034 11.967C10.5089 11.9992 9.99657 12 9.23333 12V14ZM12.5 8.73333C12.5 9.49657 12.4992 10.0089 12.467 10.4034C12.4357 10.7862 12.3799 10.9692 12.3183 11.09L14.1004 11.998C14.3295 11.5483 14.419 11.0727 14.4603 10.5662C14.5008 10.0714 14.5 9.46357 14.5 8.73333H12.5ZM12.498 13.6004C13.1879 13.2488 13.7488 12.6879 14.1004 11.998L12.3183 11.09C12.1586 11.4036 11.9036 11.6586 11.59 11.8183L12.498 13.6004ZM2.5 5.26667C2.5 4.50343 2.50078 3.99114 2.53301 3.59664C2.56429 3.21381 2.62013 3.03076 2.68166 2.91002L0.899643 2.00203C0.670518 2.45172 0.581036 2.92726 0.539652 3.43377C0.499222 3.92861 0.5 4.53643 0.5 5.26667H2.5ZM5.76667 0C5.03643 0 4.42861 -0.000777721 3.93377 0.0396522C3.42726 0.081036 2.95172 0.170518 2.50203 0.399643L3.41002 2.18166C3.53076 2.12013 3.71381 2.06429 4.09664 2.03301C4.49114 2.00078 5.00343 2 5.76667 2V0ZM2.68166 2.91002C2.84144 2.59641 3.09641 2.34144 3.41002 2.18166L2.50203 0.399643C1.81211 0.751179 1.25118 1.31211 0.899643 2.00203L2.68166 2.91002ZM8.48776 8.7998L14.2096 3.03797L12.7904 1.62869L7.06862 7.39052L8.48776 8.7998ZM8.01471 7.39052L5.5429 4.90142L4.12377 6.3107L6.59558 8.7998L8.01471 7.39052ZM7.06862 7.39052C7.32934 7.12797 7.75399 7.12797 8.01471 7.39052L6.59558 8.79979C7.11702 9.32488 7.96632 9.32488 8.48776 8.79979L7.06862 7.39052Z"
                              fill="#0D0D0D"
                            />
                          </svg>
                          {findDisplayName(
                            "portTableCheckinButton",
                            "Check In"
                          )}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
                <Pagination  totalPages={totalPages}
                  currentPage={currentPage}
                  onPageChange={onPageChange}/>
          </div>
        </div>
      )}
    </>
  );
};

export default PortTable;
